import { render, staticRenderFns } from "./PanelEmbed.vue?vue&type=template&id=0fcfc9ce&"
import script from "./PanelEmbed.vue?vue&type=script&lang=js&"
export * from "./PanelEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PanelEmbed.vue?vue&type=style&index=0&id=0fcfc9ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports